<template>
  <div>
    <b-card class="standardpage border-none">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="ticketingfees.icon" class="mr-1"></i>
            <span>{{ ticketingfees.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                  <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                    :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                    :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                    search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Category" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="category" :debounce="ticketingfees.debounce"
                      placeholder="Category"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!category" @click="category = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="ticketingfees" :icon="ticketingfees.icon"
            :busy="ticketingfees.busy" :toolbarlibrary="ticketingfees.toolbarlibrary" :tools="ticketingfees.tools"
            :badges="ticketingfees.badges" :fields="ticketingfees.fields" :items="ticketingfees.items"
            :limit="ticketingfees.limit" :downloaded="ticketingfees.downloaded" :showpages="true"
            :offset="ticketingfees.offset" :page="ticketingfees.page" @load="ticketingfees_load"
            @click="ticketingfees_click" @changed="ticketingfees_click('save', $event)" @select="ticketingfees_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="ticketingfees.selected" :config="cconfig"
          @discard="ticketingfees_click('discard')" @go="ticketingfees_click('go')"></component>
      </div>
      <b-card-footer class="mt-2 ml-1">
        <div class="text-center">
          <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
            <i class="fa fa-cogs mr-2"></i>Setup All
          </b-button>
        </div>
      </b-card-footer>

    </b-card>

  </div>
</template>


<script>
import gql from "graphql-tag";

import TicketingFeeEdit from "./Components/Setup_TicketingFeeEdit";

export default {
  name: "TicketingFees",
  components: { TicketingFeeEdit },
  watch: {
    async slac() {
      await this.ticketingfees_load(0);
    },
    async category() {
      await this.ticketingfees_load(0);
    },
  },
  data() {
    return {
      slac: null,
      category: null,
      ticketingfees: {
        title: "Ticketing Fees",
        icon: "fa fa-list",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,download,clipboard,add,edit,notes,deleteconfirm,perslac",
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-clipboard text-black",
            position: "toolbar",
            action: "perslac",
            label: "Clip by SL A/C",
            disabled: true,
            component: {
              name: "",
            },
          },

        ],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 100) {
                  result = result.slice(0, 97) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "pcc",
            label: "PCC",
            sortable: true,
          },
          {
            key: "zone",
            label: "Zone",
            sortable: true,
          },
          {
            key: "fee",
            label: "Fee",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center w-100px",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-right w-100px",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "zone",
            type: "badge",
            LCC: "white",
            EEC: "primary",
            NEEC: "danger",
            UK: "info",
          },

        ],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();
    await this.ticketingfees_load();
  },

  methods: {
    accessdenied() {
      this.ticketingfees.denied = [];
      if (!this.user.permissions.includes("setup_ticketingfees.admin")) {
        this.ticketingfees.denied.push("deleteconfirm");
      }
      if (!this.user.permissions.includes("setup_ticketingfees.admin")) {
        this.ticketingfees.denied.push("add");
        this.ticketingfees.denied.push("save");
      }

    },

    async ticketingfees_load(offset, limit, page) {
      let state = this.ticketingfees;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        category: this.category,
        slac: this.slac ? this.slac.join(",") : null,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
             query setup_ticketingfees(
              $limit: Int
              $offset: Int
              $slac: String
              $category: String
              $dateformat: String
            ) {
              setup_ticketingfees(
                limit: $limit
                offset: $offset
                category: $category
                slac: $slac
                dateformat: $dateformat
              ) {
                id
                category
                slac
                pcc
                zone
                fee
                notes
                rows
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        // USE LOCAL VARIABLE      

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.setup_ticketingfees
        } else {
          state.items = response.data.setup_ticketingfees;
        }

      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async ticketingfees_click(a, ss) {

      let state = this.ticketingfees;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.ticketingfees_load(0, 0);
          break;
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          await this.ticketingfees_load();
          break;
        case "go":
          this.component = null;
          await this.ticketingfees_load();
          break;
        case "add":
        case "edit":
          this.component = "TicketingFeeEdit";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;

        case "perslac":
          await this.perslacit(ss);
          break;
      }
    },
    async ticketingfees_select(ss, tools) {

      let state = this.ticketingfees;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download", "perslac", "clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "notes"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },
    async ticketingfees_changed(ss) {
      console.log("ticketingfees_changed", ss);
      await this.saveit(ss);
    },

    async saveit(ss) {
      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation setup_ticketingfees_save(
              $rows: [setup_ticketingfees_input]
              $dateformat: String
            ) {
              setup_ticketingfees_save(rows: $rows, dateformat: $dateformat) {
                id
                category
                slac
                zone
                fee
                notes
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
             mutation setup_ticketingfees_delete(
              $rows: [setup_ticketingfees_input]
            ) {
              setup_ticketingfees_delete(rows: $rows) {
                id

              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.ticketingfees_load(0);
    },

    async perslacit(ss) {

      let state = this.ticketingfees;
      let rows = []
      for (let j = 0; j < state.items.length; j++) {

        let item = state.items[j]

        let slacs = item.slac.split(",")
        for (let k = 0; k < slacs.length; k++) {
          let row = {
            slac: slacs[k],
            pcc: item.pcc,
            zone: item.zone,
            fee: item.fee,
            updated_by: item.updated_by,
            updated_at: item.updated_at
          }
          rows.push(row)
        }
      }

      let result = ""
      for (let j = 0; j < rows.length; j++) {
        let line = "";

        // HEADER
        if (j == 0) {
          for (let k = 0; k < state.fields.length; k++) {
            if (state.fields[k].key == "selected" || state.fields[k].key == "icon" || state.fields[k].key == "actions") {
            } else {
              line += state.fields[k].label + "\t";
            }
          }
          if (line.length > 0) {
            line = line.slice(0, -1);
          }
          result += line + "\n";
          line = "";
        }

        let obj = rows[j];

        // USE FIELDS IN CASE AN OBJECT IS NOT COMPLETE
        for (let k = 0; k < state.fields.length; k++) {
          let value = "";
          if (state.fields[k].key == "selected" || state.fields[k].key == "icon" || state.fields[k].key == "actions") {
          } else {
            value = obj[state.fields[k].key] ? obj[state.fields[k].key] : ""
            if (value) {
              value = value
                .toString()
                .replace(/(\r\n|\n|\r)/gm, "")
                .replace(/""/g, '"');
            }
            line += value + "\t";
          }

        }
        if (line.length > 0) {
          line = line.slice(0, -1);
        }

        result += line + "\n";
      }
      await navigator.clipboard.writeText(result);
    },
  },
};
</script>

<style></style>